// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.label[data-v-6a28c2df] {\n  width: 100px;\n  float: left;\n  height: 36px;\n  line-height: 36px;\n  padding: 0px 16px 0px 2px;\n  font-size: 16px;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
